import '.ag{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.gu{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.as{align-items:flex-start;}.ssr-plugin'
import '.d7{padding:2rem;}.ssr-plugin'
import '.dp{background:var(--palette-white);}.ssr-plugin'
import '.bf{overflow:hidden;}.ssr-plugin'
import '.bq{position:absolute;}.ssr-plugin'
import '.jo{top:50%;}.ssr-plugin'
import '.jp{right:1rem;}.ssr-plugin'
import '.jq{transform:translateY(-50%);}.ssr-plugin'
import '.jr{width:120px;}.ssr-plugin'
import '.js{height:120px;}.ssr-plugin'
import '.jt{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.iw{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.ju{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jv{font-size:4rem;}.ssr-plugin'
import '.c0{font-weight:700;}.ssr-plugin'
import '.jw{line-height:100%;}.ssr-plugin'
import '.i2{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ag n gu d e ad as d7 dp bf"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bq jo jp jq jr js jt d r ad"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ag iw d e as s ju"
      >
        <div className="jv c0 jw i2 a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
